import type { ColumnDef } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';
import { IoMdCheckmark } from 'react-icons/io';

export const HistoryColumn: ColumnDef<File> = {
  id: 'historique',
  accessorFn: (row) => row.historique,
  header: 'Historique',
  cell: (props) => (
    <div className="flex w-full items-center justify-center">
      {props.getValue() ? <IoMdCheckmark className="text-lg" /> : '-'}
    </div>
  ),
  enableSorting: false,
  size: 100,
};
